import React from 'react';
import commonUtil from '../../../utils/commonUtil';

class Favourite extends React.Component {
  constructor(props) {
    super(props);
    this.items = {};
    this.state = {
      checked: props.checked,
    };
  }
  handleChange = (e) => {
    e.preventDefault();
    if (!this.props.disabled) {
      const nextValue = e.target.checked ? 'false' : 'true';  // this.items[e.target.getAttribute('value')] === 'true' ? 'false' : 'false';
      this.items[e.target.getAttribute('value')] = nextValue;
      this.setState({
        checked: !this.state.checked, // ? 'false' : 'true',
      });
      this.checked = !this.checked;
      const giftItemId = e.target.getAttribute('giftItemId');
      const skuId = e.target.getAttribute('skuId');
      this.props.onchange(giftItemId, skuId, this.checked);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked,
    });
  }

  clearState = () => {
    this.setState({
      checked: '',
    });
  }

  render() {
    let className;
    this.checked = this.state.checked;// ? this.checked : this.props.checked;
    if (this.checked) {
      className = 'icon-estrella_solida';
    } else {
      className = 'icon-estrella_linea unselected';
    }

    return (
      <React.Fragment>
        {
          this.props.display === 'icons' ?
            <React.Fragment>
              {this.checked ? 
                <img className='star-iconfull' src={commonUtil.getAssetURL() + '/images/star_fill.svg'} alt="star" onClick={this.handleChange} checked={this.checked} giftItemId={this.props.item && this.props.item.giftItemId} skuId={this.props.item && this.props.item.skuId}/>              
              :
                <img className='star-iconfull' src={commonUtil.getAssetURL() + '/images/star.svg'} alt="star_fill" onClick={this.handleChange} checked={this.checked} giftItemId={this.props.item && this.props.item.giftItemId} skuId={this.props.item && this.props.item.skuId}/>
              }
            </React.Fragment>
            :
            <React.Fragment>
              <input className="checkStar" id={`boxStar${this.props.id}`} type="checkbox" value={this.props.item && this.props.item.giftItemId} giftItemId={this.props.item && this.props.item.giftItemId} checked={this.checked} disabled={(this.props.disabled) ? 'disabled' : null} />
              <label className={this.props.tooltipData ? 'tooltip-container' : ''} htmlFor={`boxStar${this.props.id}`} onClick={this.handleChange} value={this.props.item && this.props.item.giftItemId} giftItemId={this.props.item && this.props.item.giftItemId} checked={this.checked}>
                {this.props.tooltipData ? this.props.tooltipData : null}
              </label>
            </React.Fragment>
        }
      </React.Fragment>
    );
  }
}
export default Favourite;
